import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/portal/user'

export const CLOUD_SPACE_MIN_AVAILABLE_MB = 5
export const CLOUD_SPACE_INSUFFICIENT_MSG = '云盘空间不足，请扩容或删除现有文件后再操作'

export function getCloudAvailableSpaceMb(userInfo) {
  if (!userInfo) return 0
  const totalQuota = Number(userInfo.totalQuota) || 0
  const usedQuota = Number(userInfo.usedQuota) || 0
  if (totalQuota <= 0) return Infinity
  return totalQuota - usedQuota
}

export function hasEnoughCloudSpace(userInfo, minAvailableMb = CLOUD_SPACE_MIN_AVAILABLE_MB) {
  const available = getCloudAvailableSpaceMb(userInfo)
  if (available === Infinity) return true
  return available >= minAvailableMb
}

export function showCloudSpaceInsufficientMessage() {
  ElMessage.warning(CLOUD_SPACE_INSUFFICIENT_MSG)
}

export function ensureEnoughCloudSpaceFromUserInfo(userInfo, options = {}) {
  const { showMessage = true, minAvailableMb = CLOUD_SPACE_MIN_AVAILABLE_MB } = options
  if (hasEnoughCloudSpace(userInfo, minAvailableMb)) {
    return true
  }
  if (showMessage) {
    showCloudSpaceInsufficientMessage()
  }
  return false
}

export async function ensureEnoughCloudSpace(options = {}) {
  const { refresh = true } = options
  let userInfo = null
  if (refresh) {
    const userStore = useUserStore()
    userInfo = await userStore.getUserInfo()
  } else {
    const userInfoStr = localStorage.getItem('userInfo')
    userInfo = userInfoStr ? JSON.parse(userInfoStr) : null
  }
  return ensureEnoughCloudSpaceFromUserInfo(userInfo, options)
}
